import {StyleSheet, Platform, Dimensions} from 'react-native';
import { COLORS } from '../src/constants/colors';

const SUBTLE_SHADOW = {
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 2,
};

const styles = StyleSheet.create({
  pageWrapper: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    flex: 1,
    padding: 20,
    paddingTop: 0,
    height: '100%',
  },

  navBar: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 0,
  },
  navBarLeft: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 8,
  },
  navBarRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    paddingBottom: 12,
  },
  deviceToggleWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#0a0a0a',
  },
  deviceToggleButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  deviceToggleButtonActive: {
    backgroundColor: COLORS.BRAND_PRIMARY,
  },
  deviceToggleButtonInactive: {
    backgroundColor: 'transparent',
  },
  deviceToggleTextActive: {
    color: COLORS.BRAND_TEXT,
    fontSize: 14,
  },
  deviceToggleTextInactive: {
    color: '#aaa',
    fontSize: 14,
  },
  navBarText: {
    fontSize: 14,
    color: '#666',
  },
  logoutButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: COLORS.BRAND_PRIMARY,
    borderRadius: 4,
  },
  logoutButtonText: {
    color: COLORS.BRAND_TEXT,
    fontSize: 14,
  },
  leftPane: {
    flex: 1,
    paddingRight: Platform.OS === 'web' ? 20 : 0,
  },

  fileUploadSection: {
  marginBottom: 24,
},

  rightPane: {
    flex: 2,
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 12,
  },

  previewScrollView: {
    backgroundColor: '#f7f7f7',
  },
  // Tab navigation styles
  tabBar: {
    flexDirection: 'row',
    borderBottomColor: '#555',
    borderBottomWidth: 1,
    paddingHorizontal: 10,
  },
  tabButton: {
    paddingVertical: 16,
    marginBottom: 0,
    marginHorizontal: 10,
  },
  tabButtonActive: {
    borderBottomColor: COLORS.BRAND_PRIMARY,
    borderBottomWidth: 3,
  },
  tabButtonTextActive: {
    color: COLORS.BRAND_PRIMARY,
    fontWeight: '600',
  },
  tabButtonInactive: {
    borderBottomColor: 'transparent',
    borderBottomWidth: 3,
  },
  tabButtonTextInactive: {
    color: '#555',
    fontWeight: '500',
  },

  container: {
    paddingHorizontal: 1,
    paddingVertical: 0
  },

  heading: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 15,
  },

  sectionWrapper: {
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
    ...SUBTLE_SHADOW,
  },

  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 12,
    color: '#fff',
  },

  sectionHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },

  uploadBox: {
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    ...SUBTLE_SHADOW,
  },

  boxLabelText: {
    fontSize: 16,
    color: '#fff',
    marginBottom: 12,
  },

  boxLabelTextFilePicker: {
    fontSize: 16,
    color: '#fff',
  },

  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 10,
    marginBottom: 10,
  },

  input: {
    height: 40,
    color: '#fff',
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 8,
    paddingHorizontal: 10,
    marginBottom: 10,
  },

  inputHalf: {
    flexGrow:1,
    flexBasis: '48%',
    minWidth: 120,
    marginBottom: 10
  },

  textArea: {
    color: '#fff',
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    padding: 8,
    borderRadius: 8,
    marginBottom: 10,
    height: 100,
    textAlignVertical: 'top',
  },

  button: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minWidth: 120
  },

  buttonRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 12,
    marginBottom: 12,
  },

  primaryButton: {
    backgroundColor: COLORS.BRAND_PRIMARY,
  },

  primaryButtonText: {
    color: COLORS.BRAND_TEXT,
    fontSize: 16,
  },

  secondaryButton: {
    backgroundColor: '#555',
  },

  secondaryButtonText: {
    color: '#fff',
    fontSize: 16,
  },

  removeBtnDisabled: {
    opacity: 0.5,
  },
  
  generatedJsonContainer: {
    maxHeight: 300,
    backgroundColor: '#FFFFFF',
    padding: 10,
    borderRadius: 4,
    marginTop: 10,
  },

  placeholderText: {
    fontStyle: 'italic',
    color: '#888',
    marginTop: 10,
  },

  keywordsBox: {
    minHeight: 90,
    backgroundColor: '#000',
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 6,
    padding: 10,
  },

  keywordsText: {
    fontSize: 14,
    color: '#444',
  },
  researchBox: {
  minHeight: 60,
  maxHeight: 120,
  backgroundColor: '#000',
  borderColor: '#ddd',
  borderWidth: 1,
  borderRadius: 6,
  padding: 10,
  overflow: 'hidden',
},

researchScroll :{
  flex: 1,
},

researchText: {
  fontSize: 14,
  color: '#444',
},
  progressBarContainer: {
    height: 20,
    backgroundColor: '#fff',
    borderRadius: 10,
    overflow: 'hidden',
    marginVertical: 10,
    position: 'relative',
  },
  progressBar: {
    height: '100%',
    backgroundColor: COLORS.BRAND_PRIMARY,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  progressText: {
    color: COLORS.BRAND_TEXT,
    fontWeight: 'bold',
    paddingHorizontal: 8,
    fontSize: 12,
  },
  progressStatusText: {
    textAlign: 'center',
    marginBottom: 10,
    fontSize: 14,
    color: '#666',
  },
checkboxGroup: {
  marginBottom: 16,
  marginTop: 11
},


checkboxRow: {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 12,
},

checkboxLabel: {
  marginLeft: 8,
  fontSize: 14,
  color: COLORS.BRAND_TEXT,
},

actionRow: {
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap',
},

configButton: {
  padding: 8,
  borderRadius: 8,
  backgroundColor: '#555',
  alignItems: 'center',
  justifyContent: 'center',
},

gearIcon: {
  fontSize: 20,
},

generateCancelGroup: {
  flexDirection: 'row',
  gap: 12,
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
},
modalOverlay: {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  elevation: 10, // For Android
},

modalContent: {
  width: '90%',
  maxWidth: 600,
  backgroundColor: '#000',
  borderRadius: 12,
  padding: 20,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.3,
  shadowRadius: 8,
  elevation: 8, // For Android
},

closeButton: {
  marginTop: 20,
  alignSelf: 'center',
  backgroundColor: '#666',
  paddingVertical: 10,
  paddingHorizontal: 20,
  borderRadius: 6,
},

closeButtonText: {
  color: 'white',
  fontWeight: '600',
},

 loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
    borderRadius: 12,
    borderWidth: 3,
    borderColor: COLORS.BRAND_PRIMARY,
    paddingVertical: 60,
    paddingHorizontal: 30,
    margin: 10,
    shadowColor: COLORS.BRAND_PRIMARY,
    shadowOpacity: 0.25,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 0 },
    elevation: 5,
  },
  loadingIcon: {
    fontSize: 48,
    marginBottom: 20,
    lineHeight: 48,
  },
  loadingText: {
    fontSize: 20,
    fontWeight: '600',
    textAlign: 'center',
    color: COLORS.BRAND_PRIMARY,
  },
  loadingIndicator: {
    marginTop: 20,
  },
  htmlWebViewContainer: {
    width: '100%',
    // no fixed height or flex: allow natural height so ScrollView can clip
  },
  htmlContent: {
    padding: 0,
    fontFamily: 'sans-serif',
    // let content size itself
  },
  authContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '100vh'
  },
  authLogoPane: {
    width: 300,            
    height: 300,
    marginRight: 20,       
    backgroundColor: 'transparent',
  },
  authWrapper: {
    backgroundColor: 'transparent', 
    flexDirection: 'row',
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  authFormPane: {
    width: 300,            
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    padding: 0,
  },
  authCard: {
    width: '100%',
    maxWidth: 300,
    padding: 20,
    borderColor: COLORS.BRAND_PRIMARY,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 12,
  },
  centerWrapper: {
    alignSelf: 'center',      
    justifyContent: 'center', 
    width: Platform.OS === 'web' ? 800 : '100%',  
    maxWidth: '90%',          
    padding: 0,   
  },
  authTitle: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
  },
  authInput: {
    color: '#fff',
    height: 40,
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 8,
    paddingHorizontal: 10,
    marginBottom: 12,
  },
  authError: {
    color: '#ff0000',
    marginBottom: 8,
    textAlign: 'center',
  },
  authToggle: {
    marginTop: 12,
    color: COLORS.BRAND_PRIMARY,
    textAlign: 'center',
  },

  // --- Creative Studio (right pane) ---
  creativeStudioScroll: {
    paddingHorizontal: 20,
  },
  creativeStudioContent: {
    paddingVertical: 20,
    gap: 20,
  },
  creativeTopRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  creativeCard: {
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 10,
    padding: 12,
    backgroundColor: '#000',
  },
  creativeCardHalf: {
    flexGrow: 1,
    flexBasis: 320,
    minWidth: 280,
  },
  creativeCardTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#fff',
    marginBottom: 12,
  },
  creativeSegmented: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 10,
    overflow: 'hidden',
  },
  creativeSegmentButton: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  creativeSegmentActive: {
    backgroundColor: COLORS.BRAND_PRIMARY,
  },
  creativeSegmentInactive: {
    backgroundColor: 'transparent',
  },
  creativeSegmentText: {
    fontSize: 14,
  },
  creativeSegmentTextActive: {
    color: COLORS.BRAND_TEXT,
  },
  creativeSegmentTextInactive: {
    color: '#aaa',
  },

  creativeQtyRow: {
    marginTop: 10,
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
  },
  creativeQtyChip: {
    width: 44,
    height: 34,
    borderRadius: 8,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  creativeQtyChipActive: {
    borderColor: COLORS.BRAND_PRIMARY,
    backgroundColor: COLORS.BRAND_PRIMARY,
  },
  creativeQtyChipInactive: {
    borderColor: '#555',
    backgroundColor: 'transparent',
  },
  creativeQtyChipText: {
    fontSize: 14,
  },
  creativeQtyChipTextActive: {
    color: COLORS.BRAND_TEXT,
  },
  creativeQtyChipTextInactive: {
    color: '#555',
  },

  creativeTwoColRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: 12,
    alignItems: 'center',
  },
  creativeCheckRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  creativeResolutionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  creativePickerContainer: {
    width: 220,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    backgroundColor: '#000',
    overflow: 'hidden',
    paddingVertical: 6,
  },
  creativePickerContainerDisabled: {
    opacity: 0.6,
  },
  creativePicker: {
    width: 220,
    fontSize: 16,
    color: '#fff',
    borderWidth: 0,
    backgroundColor: '#000',
  },

  creativeBrandRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  creativeBrandInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    color: '#fff',
    backgroundColor: 'transparent',
  },
  creativeIconButton: {
    width: 44,
    height: 42,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#555',
  },
  creativeIconButtonText: {
    fontSize: 18,
    color: '#fff',
  },

  creativeActionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 4,
  },
  creativeCostPill: {
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: 'transparent',
  },
  creativeCostText: {
    fontSize: 16,
    color: COLORS.BRAND_PRIMARY,
  },
  creativeGenerateButton: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: COLORS.BRAND_PRIMARY,
    minWidth: 240,
    alignItems: 'center',
    justifyContent: 'center',
  },
  creativeGenerateButtonDisabled: {
    opacity: 0.85,
  },
  creativeGenerateButtonText: {
    color: COLORS.BRAND_TEXT,
    fontSize: 16,
  },
  creativePreviewFrame: {
    backgroundColor: '#fff',
    height: 440,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12,
  },
  creativePreviewFrameResults: {
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  creativePreviewCenter: {
    alignItems: 'center',
  },
  creativePreviewIcon: {
    fontSize: 18,
    color: COLORS.BRAND_PRIMARY,
    marginBottom: 6,
  },
  creativePreviewTitle: {
    fontSize: 14,
    fontWeight: '800',
    color: COLORS.BRAND_PRIMARY,
  },
  creativePreviewSubtitle: {
    fontSize: 13,
    fontWeight: '700',
    color: COLORS.BRAND_PRIMARY,
  },
  creativeResultsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    paddingBottom: 6,
  },
  creativeResultsScroll: {
    width: '100%',
    flex: 1,
  },
  creativeResultCard: {
    width: '48%',
    borderWidth: 1,
    borderColor: '#e5e7eb',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
    marginBottom: 10,
  },
  creativeResultHeader: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    backgroundColor: '#f9fafb',
  },
  creativeResultLabel: {
    fontSize: 16,
    color: '#111827',
  },
  creativeResultImage: {
    width: '100%',
    height: 170,
    backgroundColor: '#f3f4f6',
  },
  creativeResultActionButton: {
    paddingVertical: 10,
    backgroundColor: COLORS.BRAND_PRIMARY,
    alignItems: 'center',
    justifyContent: 'center',
  },
  creativeResultActionText: {
    color: COLORS.BRAND_TEXT,
    fontSize: 16,
  },

  mediaTranslatorCardBody: {
    color: '#a6b5ac',
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 16,
  },
  mediaTranslatorFieldGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 14,
  },
  mediaTranslatorField: {
    flexGrow: 1,
    flexBasis: 220,
  },
  mediaTranslatorPickerShell: {
    width: '100%',
    minWidth: 220,
    flex: 1,
    minHeight: 44,
    justifyContent: 'center',
    paddingVertical: 2,
  },
  mediaTranslatorPicker: {
    width: '100%',
    minHeight: 40,
  },
  mediaTranslatorNotesInput: {
    minHeight: 96,
    paddingHorizontal: 12,
    paddingVertical: 12,
    textAlignVertical: 'top',
  },
  mediaTranslatorToolbarButton: {
    flex: 0,
    minWidth: 170,
  },
  mediaTranslatorRunButton: {
    flex: 1,
    minWidth: 0,
  },
  mediaTranslatorActionButtons: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
    width: '100%',
    marginBottom: 20,
  },
  mediaTranslatorCancelButton: {
    flex: 0,
    padding: 10,
    width: 160,
    minWidth: 160,
  },
  mediaTranslatorRunButtonDisabled: {
    opacity: 0.8,
  },
  mediaTranslatorCostHint: {
    color: '#5a6e60',
    fontSize: 12,
    textAlign: 'left',
  },
  mediaTranslatorCompactButton: {
    flex: 0,
    minWidth: 120,
  },
  mediaTranslatorAssetName: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '700',
    marginBottom: 6,
  },
  mediaTranslatorAssetSubline: {
    color: '#8da192',
    fontSize: 13,
    marginBottom: 4,
  },
  mediaTranslatorStatusSummary: {
    gap: 12,
  },
  mediaTranslatorFullWidthCard: {
    width: '100%',
    flexBasis: '100%',
  },
  mediaTranslatorErrorInline: {
    color: '#ffb6b6',
    fontSize: 13,
    lineHeight: 18,
  },
  mediaTranslatorResultPanel: {
    gap: 14,
  },
  mediaTranslatorDownloadButton: {
    minWidth: 180,
  },
  mediaTranslatorDisabledButton: {
    opacity: 0.6,
  },
  mediaTranslatorEmptyStateCompact: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: COLORS.BRAND_PRIMARY,
    backgroundColor: '#050806',
    paddingVertical: 28,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  mediaTranslatorEmptyStateBody: {
    color: '#96a99b',
    fontSize: 14,
    textAlign: 'center',
    lineHeight: 20,
  },
  mediaTranslatorProgressTrack: {
    height: 8,
    borderRadius: 999,
    backgroundColor: '#17231b',
    overflow: 'hidden',
    marginBottom: 6,
  },
  mediaTranslatorProgressFill: {
    height: '100%',
    borderRadius: 999,
    backgroundColor: COLORS.BRAND_PRIMARY,
  },
});

const toastActionBase = {
  border: 'none',
  background: 'transparent',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  padding: '12px 10px',
  textAlign: 'center',
};

export const forbiddenToastStyles = {
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1px 110px',
    width: '100%',
    backgroundColor: '#fff',
    color: '#1f2937',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    padding: 16,
    lineHeight: 1.4,
  },
  divider: {
    backgroundColor: COLORS.BRAND_PRIMARY,
    width: 1,
    height: '100%',
  },
  actions: {
    display: 'grid',
    gridTemplateRows: '1fr 1px 1fr',
    height: '100%',
  },
  settingsButton: {
    ...toastActionBase,
    backgroundColor: COLORS.BRAND_PRIMARY,
    color: '#fff',
  },
  closeButton: {
    ...toastActionBase,
    color: '#374151',
  },
  rowDivider: {
    backgroundColor: COLORS.BRAND_PRIMARY,
    width: '100%',
  },
};

export default styles;